export const enum Approaches {
    RetrieveThenRead = "rtr",
    GPT432K = "gpt432K",
    GPT4 = "gpt4",
    GPT35 = "gpt35",
    GPT3516K = "GPT3516K",
    ReadDecomposeAsk = "rda"
}

export type AskRequestOverrides = {
    semanticRanker?: boolean;
    semanticCaptions?: boolean;
    excludeCategory?: string;
    top?: number;
    temperature?: number;
    promptTemplate?: string;
    promptTemplatePrefix?: string;
    promptTemplateSuffix?: string;
    suggestFollowupQuestions?: boolean;
    Documents?: string[];
    documentOptions: string;
};

export const enum sourcePage {
    Kubota = "sourcepage",
    Cincinnati = "sourcepage",
    Claims = "ClaimNumber",
    Carlisle = "sourcepage",
    Mortgage = "sourcepage",
    SLMS = "sourcefile",
    TWOD_Support = "sourcefile",
    Supreme_Lending = "sourcepage",
    QuickChat = "metadata",
    ManufacturingManuals = "sourcepage",
    TouchlessLending = "sourcepage",
    NEWFI = "sourcepage",
    EMR = "sourcepage",
    PolicyCoverage = "sourcepage",
    FaultCodes = "ErrorId",
    Marcom = "sourcepage",
    DTNA = "sourcepage",
    KubotaGenAI = "sourcepage",
    AcraLending = "sourcepage",
    AcraLendingHyde = "sourcepage",
    LendingDocs = "sourcepage",
    SecondLien = "sourcepage",
    CincinnatiManuals = "sourcepage",
    CincinnatiHeatData = "CallID",
    PPT="sourcepage",
    Bridgestone = "sourcepage",
    LimaGrain = "sourcepage"
}

export type AskRequest = {
    question: string;
    approach: Approaches;
    overrides?: AskRequestOverrides;
};

export type AskResponse = {
    answer: string;
    thoughts: string | null;
    data_points: string[] | [];
    error?: string;
    prompt_tokens : string;
    completion_tokens : string;
    cost : string;
    total_tokens : string;
    model: string;
};

export type ChatTurn = {
    user: string;
    bot?: string;
};

export type ChatRequest = {
    history: ChatTurn[];
    approach: Approaches;
    overrides?: AskRequestOverrides;
};